module.exports = __webpack_public_path__ + "static/media/banner.046df8b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageCommercialPassword/banner.png
// module id = 656
// module chunks = 0